import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { ResizeImage } from "@temp/@prismic/components/ResizeImage";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import classNames from "classnames";
import { linkResolver } from "../../../prismic-config";

function removeDomainFromUrl(link) {
  var newUrl = new URL(link.url);
  return {
    __typename: link.__typename,
    _linkType: link._linkType,
    url: newUrl.pathname + newUrl.search
  };
}

var SLYDES_TO_SHOW_DEAFAULT_AMOUNT = 5;

var getSlydesToShowAmount = function getSlydesToShowAmount(fields) {
  if (fields) {
    return fields.length <= SLYDES_TO_SHOW_DEAFAULT_AMOUNT && fields.length >= 2 ? fields.length - 1 : SLYDES_TO_SHOW_DEAFAULT_AMOUNT;
  }

  return SLYDES_TO_SHOW_DEAFAULT_AMOUNT;
};

export function SliceInspiration(_ref) {
  var fields = _ref.fields;
  var sliderSettings = {
    arrows: true,
    autoplay: true,
    autoplaySpeed: 0,
    dots: false,
    draggable: false,
    infinite: true,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 767,
      settings: {
        autoplay: false,
        slidesToShow: 1,
        speed: 900,
        swipe: false,
        swipeToSlide: true
      }
    }],
    slidesToScroll: 1,
    slidesToShow: getSlydesToShowAmount(fields),
    speed: 1900,
    variableWidth: true
  };
  var slider = useRef(null);

  var pauseSlider = function pauseSlider() {
    if (window.innerWidth < 767) {
      return;
    }

    slider.current.slickPause();
  };

  var playSlider = function playSlider() {
    if (window.innerWidth < 767) {
      return;
    }

    slider.current.slickPlay();
  };

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      startPos = _useState2[0],
      setStartPos = _useState2[1];

  var touchStart = function touchStart(e) {
    setStartPos(e.nativeEvent.touches[0].clientX);
  };

  var touchEnd = function touchEnd(e) {
    var endPos = e.nativeEvent.changedTouches[0].clientX;
    var delta = startPos - endPos;
    var minDeltaValue = 25;

    if (Math.abs(delta) > minDeltaValue && delta > 0) {
      slider.current.slickNext();
    }

    if (Math.abs(delta) > minDeltaValue && delta < 0) {
      slider.current.slickPrev();
    }
  };

  var runCount = 0;
  var currentIndex = [];

  var randomClass = function randomClass(str) {
    runCount = 0;
    var index = Math.round(Math.random() * 2);

    do {
      runCount += 1;

      if (runCount > 20) {
        currentIndex = [];
      }

      if (currentIndex.length === 2) {
        if (!currentIndex.includes(0)) {
          index = 0;
        } else if (!currentIndex.includes(1)) {
          index = 1;
        } else if (!currentIndex.includes(2)) {
          index = 2;
        }
      } else {
        index = Math.round(Math.random() * 2);
      }
    } while (currentIndex.includes(index));

    if (currentIndex.length < 2) {
      currentIndex.push(index);
    } else {
      currentIndex = [index];
    }

    return "".concat(str, "__").concat(index);
  };

  return React.createElement("div", {
    className: "inspiration",
    onMouseEnter: pauseSlider,
    onMouseLeave: playSlider,
    onTouchStart: function onTouchStart(e) {
      return touchStart(e);
    },
    onTouchEnd: function onTouchEnd(e) {
      return touchEnd(e);
    }
  }, React.createElement(Slider, _extends({}, sliderSettings, {
    ref: slider
  }), fields && fields.map(function (item, i) {
    if (item.link && item.link.__typename === "_ExternalLink") {
      return React.createElement(Link, {
        to: linkResolver(removeDomainFromUrl(item.link)),
        key: "inspiration__item_".concat(i)
      }, React.createElement("div", {
        className: classNames("inspiration__item", randomClass("inspiration__item"))
      }, React.createElement(ResizeImage, item.image)));
    }

    return React.createElement("div", {
      className: classNames("inspiration__item", randomClass("inspiration__item")),
      key: "inspiration__item_".concat(i)
    }, React.createElement(ResizeImage, item.image));
  })));
}
SliceInspiration.componentName = "inspiration";
export default SliceInspiration;